/* __next_internal_client_entry_do_not_use__ NotificationBell auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=2918%3A731))
 * @trackcomponent
 * @lastsynced 2023-05-02T18:43:11.133Z
 */ export var NotificationBell = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M9.17139 20.1328C9.32246 20.7136 9.66179 21.2278 10.1362 21.5948C10.6106 21.9618 11.1933 22.1609 11.7929 22.1609C12.3926 22.1609 12.9752 21.9618 13.4496 21.5948C13.9241 21.2278 14.2634 20.7136 14.4145 20.1328",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M12.15 2.01501C14.0142 2.01501 15.8021 2.78339 17.1203 4.1511C18.4385 5.51881 19.179 7.37382 19.179 9.30806C19.179 17.4171 22.0299 17.635 22.8 17.635H1.5C2.28646 17.635 5.121 17.4001 5.121 9.30806C5.121 7.37382 5.86155 5.51881 7.17975 4.1511C8.49794 2.78339 10.2858 2.01501 12.15 2.01501Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "NotificationBell", function(strictLocalize) {
    return {
        color: Core.icon.default,
        fill: "none",
        titleAccess: strictLocalize({
            id: "u3K8H2",
            defaultMessage: [
                {
                    type: 0,
                    value: "Notification"
                }
            ]
        }),
        viewBox: "0 0 24 24"
    };
});
